module.exports = __webpack_public_path__ + "assets/img/9bd8-mz.svg";